import MiniCapture from "../MiniCapture";

const PhyMeasurementsSection = (props) => {
  const {
    isApprover,
    isRequestForChange,
    isAppprovalPending,
    handleApproverComments,
    handleApproverCheckbox,
    approverComments,
    approverCheckbox,
    mandatoryFieldRef,
    formData,
    handleDeleteImages,
    resetCaptureFlag,
    handleFormDataChange,
    isView,
    handleGapsChange,
    actionmenuFlag,
    actionImages,
    handleImagesChangeMini,
    handleResetAction,
    handleActionFieldsChange,
  } = props;



  return (
    <div className="card-body">
      <div className="col-sm-12">
        <p className="fs-6 fw-semibold">Physical Measurements - Gaps</p>
      </div>
      {isRequestForChange && isApprover && (
        <div className="form-floating d-flex justify-content-end pb-2">
          <input
            className="form-check-input custom-checkbox"
            type="checkbox"
            id="headCheckbox"
            disabled={!isAppprovalPending}
            name="head"
            checked={approverCheckbox?.head || false}
            onChange={(e) => handleApproverCheckbox(e)}
          />
        </div>
      )}
      <div className="form-floating mb-3">
        <input
          type="number"
          pattern="[0-9]*"
          inputMode="decimal"
          onKeyDown={(e) => {
            if (e.key === "-" || e.key === "e") {
              e.preventDefault(); // Prevent invalid characters
            }
          }}
          disabled={isApprover ? isView : (isView && !approverCheckbox.head)}
          className="form-control"
          id="floatingInputValue"
          placeholder="Head(mm) "
          name="head"
          ref={(el) => (mandatoryFieldRef.current.head = el)}
          value={formData.head}
          onChange={handleGapsChange}
          min={0}
        />
        <label htmlFor="floatingInputValue">
          Head(mm)<span style={{ color: "red" }}>*</span>
        </label>
        {actionmenuFlag.head && (
          <div className="col-sm-12 mb-3 border p-2 rounded">
            <MiniCapture
              isView={isApprover ? isView : (isView && !approverCheckbox.head)}
              fieldValue={"head"}
              savedImages={actionImages.head}
              formData={formData}
              onImagesChange={(images) =>
                handleImagesChangeMini(images, "head")
              }
              onResetChange={() => handleResetAction("head", "PHYSICAL")}
              onHandleActionFieldsChange={(e, field) => {
                handleActionFieldsChange(e, field, "PHYSICAL");
              }}
              onImageDelete={(index) => handleDeleteImages(index, "head")}
              reset={resetCaptureFlag}
              mandatoryFieldRef={mandatoryFieldRef}
            />
          </div>
        )}
        {isRequestForChange && (
          <div className="form-floating mb-1" style={approverCheckbox?.head ? {} : { display: "none" }}>
            <input
              type="text"
              disabled={!isAppprovalPending}
              ref={(el) =>
                (mandatoryFieldRef.current.headApproverComments = el)
              }
              className="form-control"
              id="floatingInputValue"
              name="head"
              value={approverComments?.head}
              onChange={(e) => {
                handleApproverComments(e);
              }}
            />
            <label htmlFor="floatingInputValue">
              Approver Comments for Head<span style={{ color: "red" }}>*</span>
            </label>
          </div>
        )}
      </div>
      {isRequestForChange && isApprover && (
        <div className="form-floating d-flex justify-content-end pb-2">
          <input
            className="form-check-input custom-checkbox"
            type="checkbox"
            disabled={!isAppprovalPending}
            id="hingeLocationCheckbox"
            name="hingeLocation"
            checked={approverCheckbox?.hingeLocation || false}
            onChange={(e) => handleApproverCheckbox(e)}
          />
        </div>
      )}
      <div className="form-floating mb-3">
        <select
          className="form-select"
          name="hingeLocation"
          ref={(el) => (mandatoryFieldRef.current.hingeLocation = el)}
          disabled={isApprover ? isView : (isView && !approverCheckbox.hingeLocation)}
          id="floatingSelect"
          aria-label="Floating label select example"
          value={formData.hingeLocation}
          onChange={handleFormDataChange}
        >
          <option selected>Select</option>
          <option value="1">Left</option>
          <option value="2">Right</option>
        </select>
        <label htmlFor="floatingSelect">
          Hinge Location<span style={{ color: "red" }}>*</span>
        </label>
        {isRequestForChange && (
          <div className="form-floating mb-1" style={approverCheckbox?.hingeLocation ? {} : { display: "none" }}>
            <input
              type="text"
              ref={(el) =>
                (mandatoryFieldRef.current.hingeLocationApproverComments = el)
              }
              className="form-control"
              disabled={!isAppprovalPending}
              id="floatingInputValue"
              name="hingeLocation"
              value={approverComments?.hingeLocation}
              onChange={(e) => {
                handleApproverComments(e);
              }}
            />
            <label htmlFor="floatingInputValue">
              Approver Comments for Hinge Location<span style={{ color: "red" }}>*</span>
            </label>
          </div>
        )}
      </div>
      {isRequestForChange && isApprover && (
        <div className="form-floating d-flex justify-content-end pb-2">
          <input
            className="form-check-input custom-checkbox"
            type="checkbox"
            id="noOfHingesCheckbox"
            disabled={!isAppprovalPending}
            name="noOfHinges"
            checked={approverCheckbox?.noOfHinges || false}
            onChange={(e) => handleApproverCheckbox(e)}
          />
        </div>
      )}
      <div className="form-floating mb-3">
        <input
          type="number"
          pattern="[0-9]*"
          inputMode="integer"
          onKeyDown={(e) => {
            if (e.key === "-" || e.key === "e" || e.key === ".") {
              e.preventDefault(); // Prevent invalid characters
            }
          }}
          disabled={isApprover ? isView : (isView && !approverCheckbox.noOfHinges)}
          className="form-control"
          id="floatingInputValue"
          placeholder="Number of Hinges"
          value={formData.noOfHinges}
          name="noOfHinges"
          ref={(el) => (mandatoryFieldRef.current.noOfHinges = el)}
          onChange={handleGapsChange}
          min={0}
        />
        <label htmlFor="floatingInputValue">
          Number of Hinges<span style={{ color: "red" }}>*</span>
        </label>

        {actionmenuFlag.noOfHinges && (
          <div className="col-sm-12 mb-3 border p-2 rounded">
            <MiniCapture
              isView={isApprover ? isView : (isView && !approverCheckbox.noOfHinges)}
              mandatoryFieldRef={mandatoryFieldRef}
              fieldValue={"noOfHinges"}
              savedImages={actionImages.noOfHinges}
              formData={formData}
              onImagesChange={(images) =>
                handleImagesChangeMini(images, "noOfHinges")
              }
              onResetChange={() => handleResetAction("noOfHinges", "PHYSICAL")}
              onHandleActionFieldsChange={(e, field) => {
                handleActionFieldsChange(e, field, "PHYSICAL");
              }}
              onImageDelete={(index) => handleDeleteImages(index, "noOfHinges")}
              reset={resetCaptureFlag}
            />
          </div>
        )}
        {isRequestForChange && (
          <div className="form-floating mb-1" style={approverCheckbox?.noOfHinges ? {} : { display: "none" }}>
            <input
              type="text"
              ref={(el) =>
                (mandatoryFieldRef.current.noOfHingesApproverComments = el)
              }
              className="form-control"
              id="floatingInputValue"
              name="noOfHinges"
              disabled={!isAppprovalPending}
              value={approverComments?.noOfHinges}
              onChange={(e) => {
                handleApproverComments(e);
              }}
            />
            <label htmlFor="floatingInputValue">
              Approver Comments for No. of Hinges<span style={{ color: "red" }}>*</span>
            </label>
          </div>
        )}
      </div>
      {isRequestForChange && isApprover && (
        <div className="form-floating d-flex justify-content-end pb-2">
          <input
            className="form-check-input custom-checkbox"
            type="checkbox"
            id="hingeCheckbox"
            disabled={!isAppprovalPending}
            name="hinge"
            checked={approverCheckbox?.hinge || false}
            onChange={(e) => handleApproverCheckbox(e)}
          />
        </div>
      )}
      <div className="form-floating mb-3">
        <input
          type="number"
          pattern="[0-9]*"
          inputMode="decimal"
          onKeyDown={(e) => {
            if (e.key === "-" || e.key === "e") {
              e.preventDefault(); // Prevent invalid characters
            }
          }}
          disabled={isApprover ? isView : (isView && !approverCheckbox.hinge)}
          className="form-control"
          id="floatingInputValue"
          placeholder="Hinge(mm)"
          value={formData.hinge}
          name="hinge"
          ref={(el) => (mandatoryFieldRef.current.hinge = el)}
          onChange={handleGapsChange}
          min={0}
        />
        <label htmlFor="floatingInputValue">
          Hinge(mm)<span style={{ color: "red" }}>*</span>
        </label>

        {actionmenuFlag.hinge && (
          <div className="col-sm-12 mb-3 border p-2 rounded">
            <MiniCapture
              isView={isApprover ? isView : (isView && !approverCheckbox.hinge)}
              mandatoryFieldRef={mandatoryFieldRef}
              fieldValue={"hinge"}
              savedImages={actionImages.hinge}
              formData={formData}
              onImagesChange={(images) =>
                handleImagesChangeMini(images, "hinge")
              }
              onResetChange={() => handleResetAction("hinge", "PHYSICAL")}
              onHandleActionFieldsChange={(e, field) => {
                handleActionFieldsChange(e, field, "PHYSICAL");
              }}
              onImageDelete={(index) => handleDeleteImages(index, "hinge")}
              reset={resetCaptureFlag}
            />
          </div>
        )}
        {isRequestForChange && (
          <div className="form-floating mb-1" style={approverCheckbox?.hinge ? {} : { display: "none" }}>
            <input
              type="text"
              ref={(el) =>
                (mandatoryFieldRef.current.hingeApproverComments = el)
              }
              className="form-control"
              id="floatingInputValue"
              name="hinge"
              disabled={!isAppprovalPending}
              value={approverComments?.hinge}
              onChange={(e) => {
                handleApproverComments(e);
              }}
            />
            <label htmlFor="floatingInputValue">
              Approver Comments for Hinge<span style={{ color: "red" }}>*</span>
            </label>
          </div>
        )}
      </div>

        {isRequestForChange && isApprover && (
        <div className="form-floating d-flex justify-content-end pb-2">
          <input
            className="form-check-input custom-checkbox"
            type="checkbox"
            id="closingCheckbox"
            disabled={!isAppprovalPending}
            name="closing"
            checked={approverCheckbox?.closing || false}
            onChange={(e) => handleApproverCheckbox(e)}
          />
        </div>
      )}
      <div className="form-floating mb-3">
        <input
          type="number"
          pattern="[0-9]*"
          inputMode="decimal"
          onKeyDown={(e) => {
            if (e.key === "-" || e.key === "e") {
              e.preventDefault(); // Prevent invalid characters
            }
          }}
          className="form-control"
          id="floatingInputValue"
          placeholder="Closing(mm) "
          value={formData.closing}
          disabled={isApprover ? isView : (isView && !approverCheckbox.closing)}
          name="closing"
          ref={(el) => (mandatoryFieldRef.current.closing = el)}
          onChange={handleGapsChange}
          min={0}
        />
        <label htmlFor="floatingInputValue">
          Closing(mm)<span style={{ color: "red" }}>*</span>
        </label>
        {actionmenuFlag.closing && (
          <div className="col-sm-12 mb-3 border p-2 rounded">
            <MiniCapture
              isView={isApprover ? isView : (isView && !approverCheckbox.closing)}
              mandatoryFieldRef={mandatoryFieldRef}
              fieldValue={"closing"}
              savedImages={actionImages.closing}
              formData={formData}
              onImagesChange={(images) =>
                handleImagesChangeMini(images, "closing")
              }
              onResetChange={() => handleResetAction("closing", "PHYSICAL")}
              onHandleActionFieldsChange={(e, field) => {
                handleActionFieldsChange(e, field, "PHYSICAL");
              }}
              onImageDelete={(index) => handleDeleteImages(index, "closing")}
              reset={resetCaptureFlag}
            />
          </div>
        )}
        {isRequestForChange && (
          <div className="form-floating mb-1" style={approverCheckbox?.closing ? {} : { display: "none" }}>
            <input
              type="text"
              ref={(el) =>
                (mandatoryFieldRef.current.closingApproverComments = el)
              }
              className="form-control"
              id="floatingInputValue"
              name="closing"
              disabled={!isAppprovalPending}
              value={approverComments?.closing}
              onChange={(e) => {
                handleApproverComments(e);
              }}
            />
            <label htmlFor="floatingInputValue">
              Approver Comments for Closing<span style={{ color: "red" }}>*</span>
            </label>
          </div>
        )}
      </div>

      {isRequestForChange && isApprover && (
        <div className="form-floating d-flex justify-content-end pb-2">
          <input
            className="form-check-input custom-checkbox"
            type="checkbox"
            id="thresholdCheckbox"
            disabled={!isAppprovalPending}
            name="threshold"
            checked={approverCheckbox?.threshold || false}
            onChange={(e) => handleApproverCheckbox(e)}
          />
        </div>
      )}
      <div className="form-floating mb-3">
        <input
          type="number"
          pattern="[0-9]*"
          inputMode="decimal"
          onKeyDown={(e) => {
            if (e.key === "-" || e.key === "e") {
              e.preventDefault(); // Prevent invalid characters
            }
          }}
          className="form-control"
          id="floatingInputValue"
          disabled={isApprover ? isView : (isView && !approverCheckbox.threshold)}
          placeholder="Threshold(mm) "
          ref={(el) => (mandatoryFieldRef.current.threshold = el)}
          name="threshold"
          value={formData.threshold}
          onChange={handleGapsChange}
          min={0}
        />
        <label htmlFor="floatingInputValue">
          Threshold(mm)<span style={{ color: "red" }}>*</span>
        </label>
        {actionmenuFlag.threshold && (
          <div className="col-sm-12 mb-3 border p-2 rounded">
            <MiniCapture
              isView={isApprover ? isView : (isView && !approverCheckbox.threshold)}
              mandatoryFieldRef={mandatoryFieldRef}
              fieldValue={"threshold"}
              savedImages={actionImages.threshold}
              formData={formData}
              onImagesChange={(images) =>
                handleImagesChangeMini(images, "threshold")
              }
              onResetChange={() => handleResetAction("threshold", "PHYSICAL")}
              onHandleActionFieldsChange={(e, field) => {
                handleActionFieldsChange(e, field, "PHYSICAL");
              }}
              onImageDelete={(index) => handleDeleteImages(index, "threshold")}
              reset={resetCaptureFlag}
            />
          </div>
        )}
        {isRequestForChange && (
          <div className="form-floating mb-1" style={approverCheckbox?.threshold ? {} : { display: "none" }}>
            <input
              type="text"
              ref={(el) =>
                (mandatoryFieldRef.current.thresholdApproverComments = el)
              }
              className="form-control"
              id="floatingInputValue"
              name="threshold"
              disabled={!isAppprovalPending}
              value={approverComments?.threshold}
              onChange={(e) => {
                handleApproverComments(e);
              }}
            />
            <label htmlFor="floatingInputValue">
              Approver Comments for Threshold<span style={{ color: "red" }}>*</span>
            </label>
          </div>
        )}
      </div>

      {isRequestForChange && isApprover && (
        <div className="form-floating d-flex justify-content-end pb-2">
          <input
            className="form-check-input custom-checkbox"
            type="checkbox"
            id="doorThicknessCheckbox"
            disabled={!isAppprovalPending}
            name="doorThickness"
            checked={approverCheckbox?.doorThickness || false}
            onChange={(e) => handleApproverCheckbox(e)}
          />
        </div>
      )}
      <div className="form-floating mb-3">
        <input
          type="number"
          pattern="[0-9]*"
          inputMode="decimal"
          onKeyDown={(e) => {
            if (e.key === "-" || e.key === "e") {
              e.preventDefault(); // Prevent invalid characters
            }
          }}
          className="form-control"
          id="floatingInputValue"
          disabled={isApprover ? isView : (isView && !approverCheckbox.doorThickness)}
          placeholder="Door Thickness(mm)"
          name="doorThickness"
          ref={(el) => (mandatoryFieldRef.current.doorThickness = el)}
          value={formData.doorThickness}
          onChange={handleFormDataChange}
          min={0}
        />
        <label htmlFor="floatingInputValue">
          Door Thickness(mm)
          <span style={{ color: "red" }}>*</span>
        </label>
        {isRequestForChange && (
          <div className="form-floating mb-1" style={approverCheckbox?.doorThickness ? {} : { display: "none" }}>
            <input
              type="text"
              ref={(el) =>
                (mandatoryFieldRef.current.doorThicknessApproverComments = el)
              }
              className="form-control"
              id="floatingInputValue"
              name="doorThickness"
              disabled={!isAppprovalPending}
              value={approverComments?.doorThickness}
              onChange={(e) => {
                handleApproverComments(e);
              }}
            />
            <label htmlFor="floatingInputValue">
              Approver Comments for Door Thickness<span style={{ color: "red" }}>*</span>
            </label>
          </div>
        )}
      </div>

      {isRequestForChange && isApprover && (
        <div className="form-floating d-flex justify-content-end pb-2">
          <input
            className="form-check-input custom-checkbox"
            type="checkbox"
            id="frameDepthCheckbox"
            disabled={!isAppprovalPending}
            name="frameDepth"
            checked={approverCheckbox?.frameDepth || false}
            onChange={(e) => handleApproverCheckbox(e)}
          />
        </div>
      )}
      <div className="form-floating mb-3">
        <input
          type="number"
          pattern="[0-9]*"
          inputMode="decimal"
          onKeyDown={(e) => {
            if (e.key === "-" || e.key === "e") {
              e.preventDefault(); // Prevent invalid characters
            }
          }}
          className="form-control"
          id="floatingInputValue"
          placeholder="Frame Depth(mm)"
          name="frameDepth"
          disabled={isApprover ? isView : (isView && !approverCheckbox.frameDepth)}
          ref={(el) => (mandatoryFieldRef.current.frameDepth = el)}
          value={formData.frameDepth}
          onChange={handleFormDataChange}
          min={0}
        />
        <label htmlFor="floatingInputValue">
          Frame Depth(mm)<span style={{ color: "red" }}>*</span>
        </label>
        {isRequestForChange &&  (
          <div className="form-floating mb-1" style={approverCheckbox?.frameDepth ? {} : { display: "none" }}>
            <input
              type="text"
              ref={(el) =>
                (mandatoryFieldRef.current.frameDepthApproverComments = el)
              }
              className="form-control"
              id="floatingInputValue"
              disabled={!isAppprovalPending}
              name="frameDepth"
              value={approverComments?.frameDepth}
              onChange={(e) => {
                handleApproverComments(e);
              }}
            />
            <label htmlFor="floatingInputValue">
              Approver Comments for Frame Depth<span style={{ color: "red" }}>*</span>
            </label>
          </div>
        )}
      </div>

      {isRequestForChange && isApprover && (
        <div className="form-floating d-flex justify-content-end pb-2">
          <input
            className="form-check-input custom-checkbox"
            type="checkbox"
            id="doorSizeCheckbox"
            disabled={!isAppprovalPending}
            name="doorSize"
            checked={approverCheckbox?.doorSize || false}
            onChange={(e) => handleApproverCheckbox(e)}
          />
        </div>
      )}
      <div className="form-floating mb-3">
        <input
          type="number"
          pattern="[0-9]*"
          inputMode="decimal"
          onKeyDown={(e) => {
            if (e.key === "-" || e.key === "e") {
              e.preventDefault(); // Prevent invalid characters
            }
          }}
          className="form-control"
          id="floatingInputValue"
          placeholder="Door Size(mm)"
          name="doorSize"
          disabled={isApprover ? isView : (isView && !approverCheckbox.doorSize)}
          value={formData.doorSize}
          ref={(el) => (mandatoryFieldRef.current.doorSize = el)}
          onChange={handleFormDataChange}
          min={0}
        />
        <label htmlFor="floatingInputValue">
          Door Size(mm)<span style={{ color: "red" }}>*</span>
        </label>
        {isRequestForChange && (
          <div className="form-floating mb-1" style={approverCheckbox?.doorSize ? {} : { display: "none" }}>
            <input
              type="text"
              ref={(el) =>
                (mandatoryFieldRef.current.doorSizeApproverComments = el)
              }
              className="form-control"
              id="floatingInputValue"
              name="doorSize"
              disabled={!isAppprovalPending}
              value={approverComments?.doorSize}
              onChange={(e) => {
                handleApproverComments(e);
              }}
            />
            <label htmlFor="floatingInputValue">
              Approver Comments for Door Size<span style={{ color: "red" }}>*</span>
            </label>
          </div>
        )}
      </div>

      {isRequestForChange && isApprover && (
        <div className="form-floating d-flex justify-content-end pb-2">
          <input
            className="form-check-input custom-checkbox"
            type="checkbox"
            id="fullDoorsetSizeCheckbox"
            name="fullDoorsetSize"
            disabled={!isAppprovalPending}
            checked={approverCheckbox?.fullDoorsetSize || false}
            onChange={(e) => handleApproverCheckbox(e)}
          />
        </div>
      )}
      <div className="form-floating">
        <input
          type="number"
          pattern="[0-9]*"
          inputMode="decimal"
          onKeyDown={(e) => {
            if (e.key === "-" || e.key === "e") {
              e.preventDefault(); // Prevent invalid characters
            }
          }}
          className="form-control"
          id="floatingInputValue"
          placeholder="Full Doorset Size(mm)"
          name="fullDoorsetSize"
          disabled={isApprover ? isView : (isView && !approverCheckbox.fullDoorsetSize)}
          ref={(el) => (mandatoryFieldRef.current.fullDoorsetSize = el)}
          value={formData.fullDoorsetSize}
          onChange={handleFormDataChange}
          min={0}
        />
        <label htmlFor="floatingInputValue">
          Full Doorset Size(mm)
          <span style={{ color: "red" }}>*</span>
        </label>
        {isRequestForChange && (
          <div className="form-floating mb-1" style={approverCheckbox?.fullDoorsetSize ? {} : { display: "none" }}>
            <input
              type="text"
              ref={(el) =>
                (mandatoryFieldRef.current.fullDoorsetSizeApproverComments = el)
              }
              className="form-control"
              id="floatingInputValue"
              name="fullDoorsetSize"
              disabled={!isAppprovalPending}
              value={approverComments?.fullDoorsetSize}
              onChange={(e) => {
                handleApproverComments(e);
              }}
            />
            <label htmlFor="floatingInputValue">
              Approver Comments for Full Doorset Size<span style={{ color: "red" }}>*</span>
            </label>
          </div>
        )}
      </div>
    </div>
  );
};

export default PhyMeasurementsSection;
